require('/ui/components/dropdownrow/dropdownrow.module.scss.module.css');

export const dropdownrow = "_dropdownrow_rbp5v_1";
export const dropdownrowContent = "_dropdownrow-content_rbp5v_1";
export const dropdownrowIcon = "_dropdownrow-icon_rbp5v_1";
